import { Box } from '@mui/material';
import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid';

export default function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <Box sx={{ flex: 1 }} />
            <GridToolbarQuickFilter
                debounceMs={200}
                quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
                quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
            />
        </GridToolbarContainer>
    );
}
